import {
  Box,
  Button,
  Card,
  CardMedia,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import { doc, getDoc, serverTimestamp, setDoc, updateDoc } from "firebase/firestore";
import React, { useEffect } from "react";
import { db, functions } from "../../firebase.config";

import Iconify from "../Iconify";

import { useNavigate, useParams } from "react-router-dom";
import Timer from "./Timer";
import { UserAuth } from "../../context/AuthContext";
import Modal from "@mui/material/Modal/Modal";
import Backdrop from "@mui/material/Backdrop/Backdrop";
import Fade from "@mui/material/Fade/Fade";
import { Variables } from "../../context/VariableContext";
import { httpsCallable } from "firebase/functions";

var paydunya = require("paydunya");

var setup = new paydunya.Setup({
  masterKey: "DNrUjYFV-6HiQ-NNu5-DAgU-WizSswjzZW6I",
  privateKey: "test_private_Qyqe0MaokWBMmU1m5d1kNHcj7fs",
  publicKey: "test_public_8FAyuNRDgwV2v8Yujc8QHvlYtuS",
  token: "vT8PF5dQR3zx7r9OcplJ",
  mode: "test",
  cancelURL: "http://localhost:5000/",
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
};

export default function ReserDesktop({
  event,
  montant,
  ticketsList,
  reduction,
  seance,
}) {
  var randomstring = require("randomstring");
  const { openReservation, setOpenReservation } = Variables();
  const { user } = UserAuth();
  const { eventID } = useParams();
  const [loading, setLoading] = React.useState(false);
  const [loadingF, setLoadingF] = React.useState(true);
  const [total, setTotal] = React.useState(montant);
  const [nomField, setNom] = React.useState("");
  const [prenomField, setPrenom] = React.useState("");
  const [emailField, setEmail] = React.useState("");
  const [confirmEmailField, setConfirmEmail] = React.useState("");
  const [fieldError, setError] = React.useState(false);
  const [confirmError, setConfirmError] = React.useState(false);
  const [fee, setFee] = React.useState(0);
  const [moyenPaie, setMoyenpaie] = React.useState(0);

  const handleRadioChange = (event) => {
    var tmp = event.target.value;
    if (parseInt(tmp) === 0) {
      setFee(0)
    } else if (parseInt(tmp) === 1) {
      setFee(1.5)
    } else {
      setFee(2.5)
    }
    setMoyenpaie(parseInt(event.target.value));
  };

  useEffect(() => {
    (async () => {
      try {
        setLoadingF(true);
        console.log(seance)
        const docRef0 = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef0);
        if (docSnap.exists()) {
          setEmail(docSnap.data().email);
          setNom(docSnap.data().nom);
          setPrenom(docSnap.data().prenom);
          setConfirmEmail(docSnap.data().email);
          console.log("start");
          // setLoading(false);
        }
      } catch (error) {
        console.log(error);
      }
      setLoadingF(false);
    })();
  }, []);

  //Creation de la facture
  //fonction de paiement
  const pay = async () => {
    setLoading(true);
    var montant = 0;
    if (nomField === "" || prenomField === "" || emailField === "") {
      setError(true);
      setLoading(false);
      return;
    }
    if (emailField !== confirmEmailField) {
      setConfirmError(true);
      setLoading(false);
      return;
    }

    console.log(seance)
    try {
      const addMessage = httpsCallable(functions, "initiatePay");
      const result = await addMessage({ tickets: ticketsList, uid: user ? user.uid : null, firstname: prenomField, lastname: nomField, mobile: '', email: emailField, eventid: eventID, from: 1, discount: reduction, fee: fee, seance: seance });
      console.log(result)
      window.location.href = result.data
    } catch (error) {
      console.log(error)
    }
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "90vh",
        width: "65%",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              Voulez-vous quitter la commande ?
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              Voulez-vous vraiment quitter le règlement ? Les articles que vous
              avez sélectionnés ne seront peut-être plus disponibles
              ultérieurement.
            </Typography>
            <Box
              sx={{ width: "100%", display: "flex", justifyContent: "right" }}
            >
              <Button
                sx={{
                  marginRight: 2,
                  textTransform: "initial",
                  border: "2px solid transparent",
                  color: "white",
                  backgroundColor: "black",
                  borderRadius: "7px",
                  "&:hover": {
                    backgroundColor: "white",
                    color: "black",
                    borderColor: "black",
                  },
                }}
                variant="contained"
                onClick={() => {
                  window.location.reload();
                }}
                startIcon={
                  <Iconify icon="material-symbols:arrow-back-ios-new-rounded" />
                }
              >
                Revenir aux billets
              </Button>
              <Button
                sx={{
                  textTransform: "initial",
                  border: "2px solid transparent",
                  color: "white",
                  backgroundColor: "#5E17EB",
                  borderRadius: "7px",
                  "&:hover": {
                    backgroundColor: "white",
                    color: "#5E17EB",
                    borderColor: "#5E17EB",
                  },
                }}
                variant="contained"
                onClick={() => {
                  setOpen(false);
                }}
              >
                Rester
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>
      {loadingF ? (
        <CircularProgress />
      ) : (
        <Box
          sx={{
            bgcolor: "white",
            border: "2px solid #5E17EB",
            borderRadius: " 7px",
            zIndex: 1,
          }}
        >
          <Grid container>
            {/** info de la commande */}
            <Grid item xs={12} sm={8}>
              <Grid container>
                <Grid item xs={12}>
                  <Stack padding={2} direction="row">
                    <IconButton onClick={handleOpen}>
                      <Iconify
                        icon="solar:close-circle-outline"
                        sx={{ width: 24, height: 24 }}
                      />
                    </IconButton>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      <Typography
                        variant="h6"
                        fontWeight={600}
                        textAlign="center"
                        color="#999999"
                      >
                        Commander
                      </Typography>
                    </Box>
                  </Stack>
                  <Timer />
                  <Divider />
                </Grid>
                {/** information de facturation et payer avec */}
                {
                  !loading ? <Grid
                  sx={{ overflowX: "auto", overflowY: "auto" }}
                  item
                  xs={12}
                  paddingX={10}
                  paddingY={2}
                  maxHeight={{xs: 300, sm:350, xl:500}}
                >
                  <Typography
                    paddingY={2}
                    paddingBottom={2}
                    variant="h5"
                    fontWeight={600}
                  >
                    Informations de facturation
                  </Typography>
                  <Stack>
                    <Typography></Typography>
                  </Stack>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      {fieldError && nomField === "" ? (
                        <TextField
                          value={nomField}
                          onChange={(e) => setNom(e.target.value)}
                          fullWidth
                          label="Nom"
                          size="medium"
                          error
                          helperText="Merci de remplir ce champs."
                        />
                      ) : (
                        <TextField
                          value={nomField}
                          onChange={(e) => setNom(e.target.value)}
                          fullWidth
                          label="Nom"
                          size="medium"
                        />
                      )}
                    </Grid>
                    <Grid item xs={6}>
                      {fieldError && prenomField === "" ? (
                        <TextField
                          value={prenomField}
                          onChange={(e) => setPrenom(e.target.value)}
                          fullWidth
                          label="Prenom"
                          error
                          helperText="Merci de remplir ce champs."
                        />
                      ) : (
                        <TextField
                          value={prenomField}
                          onChange={(e) => setPrenom(e.target.value)}
                          fullWidth
                          label="Prenom"
                        />
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      {fieldError && emailField === "" ? (
                        <TextField
                          type="email"
                          value={emailField}
                          onChange={(e) => setEmail(e.target.value)}
                          fullWidth
                          label="Email"
                          error
                          helperText="Une adresse email est requise."
                        />
                      ) : (
                        <TextField
                          value={emailField}
                          onChange={(e) => setEmail(e.target.value)}
                          fullWidth
                          label="Email"
                        />
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      {fieldError && confirmEmailField === "" ? (
                        <TextField
                          value={confirmEmailField}
                          onChange={(e) => setConfirmEmail(e.target.value)}
                          fullWidth
                          label="Confirmer l'email "
                          error
                          helperText="Une adresse email est requise"
                        />
                      ) : (
                        <TextField
                          value={confirmEmailField}
                          onChange={(e) => setConfirmEmail(e.target.value)}
                          fullWidth
                          label="Confirmer l'email "
                          error={confirmError ? true : false}
                          helperText={
                            confirmError
                              ? "Les emails doivent être identiques."
                              : ""
                          }
                        />
                      )}
                    </Grid>
                  </Grid>
                  <Stack paddingY={5}>
                    <FormControlLabel
                      control={<Checkbox defaultChecked />}
                      label="Tenez-moi au courant des autres événements et des nouvelles de cet organisateur."
                    />
                    <FormControlLabel
                      control={<Checkbox defaultChecked />}
                      label="Envoyez-moi des e-mails sur les meilleurs événements ayant lieu dans mes environ ou en ligne."
                    />
                  </Stack>
                  {reduction && (montant - reduction.value) === 0 ? <></> : montant === 0 ? <></> :
                  <>
                  <Typography variant="h5" fontWeight={600}>
                    Payer avec
                  </Typography>

                  <Box
                    marginTop={2}
                    marginBottom={5}
                    sx={{ border: " 0.5px solid #999999" }}
                  >
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      value={moyenPaie}
                      name="radio-buttons-group"
                      onChange={(e) => {
                        handleRadioChange(e);
                      }}
                    >
                      <Grid
                        container
                        sx={{ border: " 0.5px solid #999999" }}
                        paddingY={2}
                      >
                        <Grid item xs={1} paddingX={1}>
                          <FormControlLabel value={0} control={<Radio />} />
                        </Grid>
                        <Grid item xs={8} display="center" alignItems="center">
                          Mobile Money & Wave
                        </Grid>
                        <Grid item xs={2}></Grid>
                      </Grid>
                      <Grid
                        container
                        sx={{ border: " 0.5px solid #999999" }}
                        paddingY={2}
                      >
                        <Grid item xs={1} paddingX={1}>
                          {" "}
                          <FormControlLabel value={1} control={<Radio />} />
                        </Grid>
                        <Grid item xs={10} display="center" alignItems="center">
                          Carte de débit ou de crédit
                        </Grid>
                        <Grid item xs={1} display="center" alignItems="center">
                          <Iconify
                            icon="bi:credit-card-2-back"
                            sx={{ width: 30, height: 30 }}
                          />
                        </Grid>
                        {moyenPaie === 1 ? (
                          <Grid container spacing={2} paddingY={1} paddingX={3}>
                            <Grid item xs={12}>
                              <TextField
                                fullWidth
                                label="Numéro de la carte"
                                size="medium"
                              />
                            </Grid>
                            <Grid item xs={8}>
                              <TextField fullWidth label="Date d'experation" />
                            </Grid>
                            <Grid item xs={4}>
                              <TextField fullWidth label="CVV" />
                            </Grid>
                          </Grid>
                        ) : null}
                      </Grid>
                      <Grid
                        container
                        sx={{ border: " 0.5px solid #999999" }}
                        paddingY={2}
                      >
                        <Grid item xs={1} paddingX={1}>
                          {" "}
                          <FormControlLabel value={2} control={<Radio />} />
                        </Grid>
                        <Grid item xs={10} display="center" alignItems="center">
                          PayPal
                        </Grid>
                        <Grid item xs={1} display="center" alignItems="center">
                          <Iconify
                            icon="logos:paypal"
                            sx={{ width: 30, height: 30 }}
                          />
                        </Grid>
                      </Grid>
                    </RadioGroup>
                  </Box>
                    </>}
                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label="Envoyez-moi des e-mails sur les meilleurs événements ayant lieu dans mes environ ou en ligne."
                  />
                </Grid>: <Grid
                  sx={{ overflowX: "auto", overflowY: "auto" }}
                  item
                  xs={12}
                  paddingX={10}
                  paddingY={2}
                  maxHeight={500}
                  minHeight={300}
                >
                  <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', height:'100%'}}>
                    <CircularProgress sx={{ color: "5E17EB"}} size={100} />
                  </Box>
                  
                </Grid>
                }
                
                {/** Bouton de commander */}
                <Grid item xs={12}>
                  <Divider />
                  <Stack padding={2}>
                    <Button
                      onClick={ async() => {
                        setLoading(true);
                        await pay();
                      }}
                      sx={{
                        textTransform: "initial",
                        border: "2px solid transparent",
                        color: "white",
                        backgroundColor: "#5E17EB",
                        borderRadius: "7px",
                        
                      }}
                      variant="contained"
                    >
                      {loading ? (
                        <CircularProgress sx={{ color: "white", "&:hover": {
                          color: "#5E17EB",
                        }, }} />
                      ) : (
                        "Commander"
                      )}
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
            {/** resumé de la commande */}
            <Grid item xs={12} sm={4} sx={{ bgcolor: "#F2ECFD" }}>
              <Grid container>
                <Grid item xs={12}>
                  <Card elevation={0}>
                    {event && (
                      <CardMedia
                        component="img"
                        sx={{ width: "100%", objectFit: "cover" }}
                        height="200"
                        image={event.idVisuel}
                        title="green iguana"
                      />
                    )}
                  </Card>
                </Grid>
                <Grid item xs={12}>
                  <Stack spacing={1} padding={2}>
                    <Typography>Résumé de la commande</Typography>
                    {ticketsList.map((billet, index) => (
                      <Box color="#999999">
                        <Stack direction="row" justifyContent="space-between">
                          <Typography>
                            {billet.quantite}x {billet.nom}
                          </Typography>
                          <Typography>{billet.prix} CFA</Typography>
                        </Stack>
                      </Box>
                    ))}

                    <Divider />
                    {(moyenPaie === 1 || moyenPaie === 2) && (
                      <Stack direction="row" justifyContent="space-between">
                        <Typography fontSize={14}>Frais de service ({fee}%)</Typography>
                        <Typography fontSize={14}>+{reduction ? (montant - reduction.value)*fee/100 : montant*fee/100} CFA</Typography>
                      </Stack>
                    )}
                    {reduction && (
                      <Stack direction="row" justifyContent="space-between">
                        <Typography fontSize={14}>Réduction</Typography>
                        <Typography fontSize={14}>
                          -{reduction.value} CFA
                        </Typography>
                      </Stack>
                    )}

                    <Stack direction="row" justifyContent="space-between">
                      <Typography>Total à payer</Typography>
                      <Typography>
                        {reduction ? montant - reduction.value +((montant - reduction.value)*fee/100) : montant + (montant*fee/100)} CFA
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  );
}
